<template>
    <div data-test-id="health-check-temperature">{{ temperatureDisplay }}</div>
</template>

<script>
import { isNumber } from 'lodash'
import canToast from '@/mixins/canToast'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'

export default {
    mixins: [canToast, needsOrganizationSlug],
    props: ['row'],

    computed: {
        temperatureDisplay() {
            const value = this.row.temperature
            if (!isNumber(value)) {
                return 'Unknown'
            }

            let fahrenheit = (value * 9) / 5 + 32
            if (!Number.isInteger(fahrenheit)) {
                fahrenheit = fahrenheit.toFixed(1)
            }
            return `${value}° C / ${fahrenheit}° F`
        },
    },
}
</script>
